import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=81d31cda&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=81d31cda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d31cda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81d31cda')) {
      api.createRecord('81d31cda', component.options)
    } else {
      api.reload('81d31cda', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=81d31cda&scoped=true&", function () {
      api.rerender('81d31cda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Zea4E1k6xWmL/JS/comp/DocBox.vue"
export default component.exports